<div class="loading" [attr.aria-busy]="loading$ | async">
  <div
    role="status"
    aria-atomic="true"
    class="sr-only"
  >
    <ng-container *ngIf="loading$ | async">{{
      'COMMON.LOADING_IN_PROGRESS' | translate
    }}</ng-container>
  </div>
  <ng-container *ngIf="loading$ | async">
    <div class="overlay" aria-hidden="true">
      <ng-ui-kit-spinner size="lg"> </ng-ui-kit-spinner>
    </div>
  </ng-container>
</div>
